import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'

const endpoint = `${apiUrl.stable}/company-geocoding`

/**
 * Return the categort information with a localized company list
 * @param {object} slug
 * @param {string} slug.category
 * @param {string} slug.serviceType
 * @param {string} slug.region
 * @param {object} [query]
 * @param {number} [query.page]
 * @param {number} [query.pagesize]
 * @param {number} [query.sort]
 * @param {number} [query.filter]
 * @returns {Promise.<{ data: ApiCategoryDirectory }>}
 */
export const getGeocoding = ({ serviceType, region }, query = {}) => {
  const url = `${endpoint}/${serviceType}/${region}`

  const headers = {
    ...jsonWebToken.header
  }

  let params = {
    pageSize: 20,
    ...query
  }

   return axios.get(url, {headers ,params })
}

export const getCompanyDetails = (id: number) => {
  const url = `${endpoint}/details/${id}`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })

}


export default {
  getGeocoding,
}